module.exports = "./img/desktop_logo.354c51c.png";